export const queryKeys = {
  dashboards: "dashboards",
  publicDashboards: "publicDashboards",
  validatePassword: "validatePassword",
  dashboardSettings: "dashboardSettings",
  dashboardAvailableModels: "dashboardAvailableModels",
};
